// extracted by mini-css-extract-plugin
export default {"WordPressShadowHost--travel-trends":"WordPressArticle_WordPressShadowHost--travel-trends__OGRhO"};